import React from 'react';
import { Program } from 'models/Program'
import Locale from 'localization/Localization';

interface ProgramListItemProps {
    program: Program;
}

export class ProgramListItem extends React.Component<ProgramListItemProps, {}>
{
    public render() {
        let url = "http://gateway.physiotoolsonline.com/PT_IntegrationService/api/PTSet/GetSet?PrintDataId="
            + this.props.program.guid;

        return (
            <div className='program-list-item' onClick={() => window.open(url, '_blank')}>
                {this.props.program.name.length > 0 ? this.props.program.name : Locale.get("programItem_unnamed")}
            </div>
        );
    }
}